<template>
  <div class="artisan-header">
    <div class="artisan-header-left" style="flex:1">
      <div style="min-width: 150px">
          <img class="header-logo-img" src="/img/logoMini.png" />
          <h1 class="header-logo-title" v-text="title"></h1>
      </div>
      <div style="flex:1;overflow: auto hidden;width:300px">
          <slot></slot>
      </div>
    </div>
    <div class="artisan-header-right" style="min-width: 230px">
      <span style="margin: 0 12px" v-text="tenant.name"></span>
      <el-popover placement="bottom-end" trigger="hover" width="200">
        <artisan-group title="角色" border>
          <el-tag
            size="mini"
            class="margin-h7"
            v-for="(item, index) in user.roles"
            :key="index"
          >
            {{ item.name }}</el-tag
          >
        </artisan-group>
        <!-- <el-button
          type="text"
          size="mini"
          icon="artisan ar-icon-theme"
          @click="drawer = true"
        >
          主题
        </el-button> -->
        <el-row type="flex" align="middle" justify="space-between">
          <el-button
            v-if="!user.isSuper"
            type="text"
            size="mini"
            @click="editPwd"
            icon="artisan ar-icon-editpwd"
          >
            变更密码
          </el-button>
        </el-row>
        <span slot="reference" style="cursor: pointer">
          <el-avatar
            style="vertical-align: middle; margin-right: 5px"
            icon="el-icon-user"
            :size="27"
            fit="fill"
            :src="user.avatar"
          ></el-avatar>
          <span v-text="user.name"></span>
          <i class="el-icon-arrow-down"></i>
        </span>
      </el-popover>
      <i style="padding-left:10px" class="artisan ar-icon-logout clickable" @click="logout"> </i>
    </div>
  </div>
</template>

<script>
import { removeToken } from "@/util/auth";
import { mapActions, mapGetters } from "vuex";
import { any } from "@/api/sys/tenant";
import { isNullOrEmpty } from "@/util/util";

import config from "@/config";
export default {
  data() {
    return {
      tenant: {},
      logo: config.logo,
      title: config.title,
    };
  },
  computed: {
    ...mapGetters(["user"]),
    userRoles() {
      return this.user.roles.map((c) => c.name).join(",");
    },
  },
  created() {
    any().then((res) => {
      this.tenant = res.data.data;
    });
    this.getUser();
  },
  methods: {
    ...mapActions(["getUser"]),
    isNullOrEmpty,

    editPwd() {
      this.$emit("editPwd");
    },
    logout() {
      this.$confirm("确认退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        removeToken();
        this.$router.push({
          path: "/login",
        });
      });
    },
  },
};
</script>

<style>
</style>